import * as React from 'react';
import { XCircleIcon } from 'lucide-react';
import type { Invoice } from 'contracts/tracking-v2/invoices'
import { Card, CardContent } from 'components/ui/card';

type Ref = {
  toggleOpen: () => void;
}

type Props = {
  invoice: Invoice;
  defaultOpen?: boolean;
}

export type DestinationPositionCardRef = Ref

export const DestinationPositionCard = React.forwardRef<Ref, Props>(({
                                                                       defaultOpen = false,
                                                                       invoice,
                                                                     }, ref) => {
  const [open, setOpen] = React.useState(defaultOpen);


  React.useImperativeHandle(ref, () => {
    return {
      toggleOpen: () => setOpen(state => !state),
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Card className={'shadow-lg'}>
      <CardContent className={'py-6 px-6 relative text-[14px] max-w-[300px]'}>
        <button className={'absolute top-1 right-1'} onClick={() => setOpen(false)}>
          <XCircleIcon className={'w-5 h-5 stroke-gray-500'} />
        </button>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Nota fiscal</p>
        <p className={'uppercase mb-4'}>
          {[invoice.infnfeIdeNnf, invoice.infnfeIdeSerie].join('-')}
        </p>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Centro</p>
        <p className={'uppercase mb-4'}>{invoice?.company?.tradeName}</p>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Endereço</p>
        <p className={'uppercase'}>{invoice?.company?.address}</p>
      </CardContent>
    </Card>
  );
});
DestinationPositionCard.displayName = 'DestinationPositionCard';